import styled from "styled-components";
import { GridPaginationOptions } from "@ecp-redux/dto/article.type";
import {
  IBoxBaseSettings,
  IElementGrid,
} from "@ecp-redux/dto/themeSettings/settingsPatterns.types";
import ConditionalHTMLElement from "../../../global/components/ConditionalHTMLElement/ConditionalHTMLElement";
import { PaginationWrapper } from "../../../global/components/Pagination/Pagination.styled";
import { checkSlidesPerView } from "../../../helpers/helpers";
import useIsMobilePortal from "../../../shared/hooks/useIsMobilePortal";

export const StyledGrid = styled(ConditionalHTMLElement).attrs((props) => ({
  renderAs: props?.renderAs ?? "div",
  ...(props?.renderAs !== "div" ? props : {}),
}))<IBoxBaseSettings<IElementGrid>>(({ $settings }) => {
  const isMobile = useIsMobilePortal();
  return `
  display: grid;
  grid-template-columns: repeat(${checkSlidesPerView(
    $settings.articlesPerRow,
    isMobile ?? false
    // TODO: globalState with platform -> SSR user agent
  )}, 1fr);
  word-break: break-all;
  gap: ${$settings.spacing.vertical}px ${$settings.spacing.horizontal}px;
  ${
    $settings.gridPaginationStyle === GridPaginationOptions.INFINITE_SCROLL &&
    `max-height: 100vh`
  };
  
  ${PaginationWrapper} {
    grid-column: 1/-1;
    margin: 15px auto 0 auto;
  }
`;
});
